import {
  buildDynamicChecklistExport,
  emptyDynamicChecklistExportContext,
  exportDocumentHasContent,
  extractDynamicSnapshot,
  fetchDynamicChecklistExportContext,
  fetchDynamicChecklistMaster,
  hasUsableDynamicPayload,
  parseChecklistPayload,
} from "../../utils/dynamicChecklistExport";
import { generateDynamicChecklistPdf } from "../../utils/dynamicChecklistPdfExport";
import downloadChecklistPDFLegacy from "./downloadChecklistPDFOld";

/**
 * Checklist PDF export for File Dashboard.
 * Uses dynamic master + saved `dynamic` snapshot when available; legacy static otherwise.
 */
const downloadChecklistPDF = async (data: any): Promise<void> => {
  const parsed = parseChecklistPayload(data?.Current_json);
  if (!parsed) {
    alert("No checklist data available.");
    return;
  }

  if (hasUsableDynamicPayload(parsed)) {
    const dynamic = extractDynamicSnapshot(parsed);
    if (!dynamic) {
      alert("No dynamic checklist data available.");
      return;
    }
    try {
      const master = await fetchDynamicChecklistMaster();
      const exportContext = data?.file_id
        ? await fetchDynamicChecklistExportContext(data.file_id)
        : await emptyDynamicChecklistExportContext();
      if (!master.length) {
        alert("Dynamic checklist master is not configured.");
        return;
      }
      const doc = buildDynamicChecklistExport(master, dynamic, parsed.remarks, exportContext);
      if (!exportDocumentHasContent(doc)) {
    alert("No meaningful checklist data to generate PDF.");
    return;
  }
      generateDynamicChecklistPdf(data, doc);
      return;
    } catch (e) {
      console.error("Dynamic PDF export failed", e);
      alert("Could not generate dynamic checklist PDF.");
      return;
    }
  }

  downloadChecklistPDFLegacy(data);
};

export default downloadChecklistPDF;
